module.exports = __webpack_public_path__ + "static/assets/30d93aa5f2b8455444e72d40206571bf.gif";